import * as React from "react";
import { styled, useTheme, Theme, CSSObject, alpha } from "@mui/material/styles";
import MuiDrawer from "@mui/material/Drawer";
import MuiAppBar, { AppBarProps as MuiAppBarProps } from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import List from "@mui/material/List";
import CssBaseline from "@mui/material/CssBaseline";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/Menu";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Box from "@mui/material/Box";
import { useStyles } from "../../theme/appStyles";
import { hiddenScrollbar } from "../../theme/scrollbars";
import {
  Avatar,
  Collapse,
  Grid,
  InputAdornment,
  ListItemButton,
  TextField,
  Tooltip,
  useMediaQuery,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import UserImg from "../../Images/avatar.png";
import { useMemo, useState } from "react";
import { useThemeContext } from "./ThemeContext";
import Notification from "../../Components/Popup/notificationDrawer";
import LogoMain from "../../Images/logo.png";
import { MdDarkMode } from "react-icons/md";
import { CiSearch } from "react-icons/ci";
import Profile from "../../Components/Popup/profile";
import { Link, useLocation, useNavigate } from "react-router-dom";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Privileges } from "../../Core/Enum/enum";
import useUser from "../../Core/hook/useUser";
import {
  useGetUserQuery,
  useGetConversationsNotificationQuery,
  useGetCustomerQuery,
  useGetAllBirthdayDhashboardQuery,
} from "../../Api/attoDeskApi";
import { IToDo, IUserInfo, ICustomer } from "../../Api/Interface/api.interface";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import useApp from "../../utils/useApp";
import Groups2Icon from "@mui/icons-material/Groups2";
// import AddTaskIcon from "@mui/icons-material/AddTask";
import PeopleIcon from "@mui/icons-material/People";
import AssignmentIcon from "@mui/icons-material/Assignment";
import AddModeratorIcon from "@mui/icons-material/AddModerator";
import PolicyIcon from "@mui/icons-material/Policy";
import CategoryIcon from "@mui/icons-material/Category";
import ArrowDropDownCircleOutlinedIcon from "@mui/icons-material/ArrowDropDownCircleOutlined";
import GroupsIcon from "@mui/icons-material/Groups";
import PlaylistAddCheckIcon from "@mui/icons-material/PlaylistAddCheck";
import { MdOutlineNotificationsNone } from "react-icons/md";
import Badge from "@mui/material/Badge";
import EmailIcon from "@mui/icons-material/Email";
import MarkEmailUnreadIcon from "@mui/icons-material/MarkEmailUnread";
import AddTaskIcon from "@mui/icons-material/AddTask";
import AddIcon from "@mui/icons-material/Add";
import { toProperCase } from "../../Components/Validation/toProperCase";
import PersonSearchRoundedIcon from "@mui/icons-material/PersonSearchRounded";
import HomeRepairServiceIcon from "@mui/icons-material/HomeRepairService";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import AccountCircleRoundedIcon from "@mui/icons-material/AccountCircleRounded";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import { prefetchRoute, prefetchCoreRoutes } from "../../Core/routePrefetch";

const drawerWidth = 280;
const headerHeight = 76;

/** Keeps the brand mark inside the shorter header without distortion. */
const logoStyle: React.CSSProperties = {
  width: "100%",
  maxHeight: 46,
  objectFit: "contain",
  height: "auto",
  display: "block",
  cursor: "pointer",
};
interface AppBarProps extends MuiAppBarProps {
  open?: boolean;
}

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})<AppBarProps>(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  height: headerHeight,
  transition: theme.transitions.create(["width", "margin"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    paddingLeft: 0,
  }),
  ...(!open && {
    marginLeft: 0,
    width: "100%",
    paddingLeft: "75px",
    [theme.breakpoints.down("md")]: {
      paddingLeft: "0px",
    },
  }),
}));

const AppBarFullScreen = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== "open",
})<AppBarProps>(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  height: headerHeight,
  transition: theme.transitions.create(["width", "margin"], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    paddingLeft: 0,
  }),
  ...(!open && {
    marginLeft: 0,
    width: "100%",
    paddingLeft: "5px",
    [theme.breakpoints.down("md")]: {
      paddingLeft: "0px",
    },
  }),
}));

const IsNotMobileDrawer = styled(MuiDrawer, {
  shouldForwardProp: (prop) => prop !== "open",
})(({ theme, open }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  display: "flex",
  flexDirection: "column",
  height: "100vh",
  ...(open && {
    ...openedMixin(theme),
    "& .MuiDrawer-paper": {
      ...openedMixin(theme),
      display: "flex",
      flexDirection: "column",
      height: "100vh",
    },
  }),
  ...(!open && {
    ...closedMixin(theme),
    "& .MuiDrawer-paper": {
      ...closedMixin(theme),
      display: "flex",
      flexDirection: "column",
      height: "100vh",
    },
  }),
}));

const MobileDrawer = styled(MuiDrawer)(({ theme }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: "nowrap",
  boxSizing: "border-box",
  display: "flex",
  flexDirection: "column",
  height: "100vh",
  "& .MuiDrawer-paper": {
    width: drawerWidth,
    height: "100vh",
    display: "flex",
    flexDirection: "column",
    /* The paper must not scroll — DrawerContent is the single scroll region. */
    overflow: "hidden",
  },
}));

const openedMixin = (theme: Theme): CSSObject => ({
  width: drawerWidth,
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  /* `hidden`, not `overflowX: hidden`: MUI's Drawer paper scrolls by default, so
     leaving it `auto` gave the rail a second scroll region — the paper and
     DrawerContent both painted a bar. DrawerContent is now the only one. */
  overflow: "hidden",
});

const closedMixin = (theme: Theme): CSSObject => ({
  transition: theme.transitions.create("width", {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  /* Same single-scroll-region rule as openedMixin. */
  overflow: "hidden",
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up("sm")]: {
    width: `calc(${theme.spacing(9)} + 1px)`,
  },
});

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  height: headerHeight,
  /* Symmetric padding. The old 75px left inset with a flex-end justification
     pushed the brand mark against the collapse control and left a dead strip
     down the left edge of the header — the one part of the rail that did not
     line up with the items below it. */
  padding: theme.spacing(0, 1.5, 0, 2.25),
  gap: theme.spacing(1),
  backgroundColor: theme.palette.topbarButton.drawerHeader,
  margin: "0px",
  ...theme.mixins.toolbar,
  minHeight: headerHeight,
  justifyContent: "space-between",
  flexShrink: 0,
  /* A light hairline: the header sits on navy, so a black rule is invisible. */
  borderBottom: `1px solid ${alpha("#ffffff", 0.08)}`,
}));

/**
 * The navigation surface. The base colour is the configured drawer colour
 * (Setting → Theme Color), deepened here with CSS only: a vertical darkening
 * gradient so the rail has a top-to-bottom fall, a soft highlight bloom behind
 * the first items, and an inner edge on the right. No image assets.
 */
const DrawerContent = styled("div")(({ theme }) => ({
  backgroundColor: theme.palette.mainMenuNav.mainNavBg,
  /* Depth without decoration: a top-to-bottom darkening so the rail has a fall,
     a soft bloom behind the first items, and an inner edge on the right. Three
     CSS gradients, no image assets. */
  backgroundImage: [
    `linear-gradient(180deg, ${alpha("#ffffff", 0.05)} 0%, transparent 24%, ${alpha(
      "#000000",
      0.18
    )} 100%)`,
    `radial-gradient(130% 240px at 0% 0%, ${alpha(
      theme.palette.mainMenuNav.hoverColorNavBg,
      0.09
    )} 0%, transparent 68%)`,
  ].join(", "),
  boxShadow: `inset -1px 0 0 ${alpha("#000000", 0.22)}`,
  /* The nav is the app's only scroll region with no visible scrollbar: the rail
     is a fixed, short list and a painted bar beside it reads as a seam. Scroll
     behaviour is untouched — wheel, touch, keyboard and scrollIntoView all still
     work; only the track and thumb are suppressed. See theme/scrollbars.ts. */
  overflowY: "auto",
  overflowX: "hidden",
  flexGrow: 1,
  minHeight: 0,
  ...hiddenScrollbar(),
}));

const PaddingBody = styled("div")(({ theme }) => ({
  height: headerHeight,
}));

/**
 * Menu entries carrying this instead of a privilege are shown to every signed-in
 * user. Used by Documentation, which holds no client data and must not depend on
 * a privilege the installation may not have seeded.
 */
export const PUBLIC_MENU_ITEM = "__public__";

type SubmenuItem = {
  topBarTitle?: string;
  title: string;
  path: string;
  newPage?: boolean;
  icon: React.ReactElement;
  privilege: string;
};

type menuList = {
  topBarTitle: string;
  title: string;
  icon: React.ReactElement;
  path: string;
  newPage?: boolean;
  submenuOpen?: boolean;
  submenus?: SubmenuItem[];
  privilege: string;
  /** Keep the item highlighted for any path beneath it (e.g. /documentation/clients). */
  matchPrefix?: boolean;
};

const MainMenuList: {
  comomTitle: string;
  menuList?: menuList[];
}[] = [
  {
    comomTitle: "General",
    menuList: [
      {
        title: "Dashboard",
        topBarTitle: "Dashboard",
        icon: <MenuIcon />,
        path: "/dashboard",
        submenuOpen: false,
        privilege: Privileges.DashboardView,
      },
      {
        title: "Client",
        topBarTitle: "Client List",
        icon: <PeopleIcon />,
        path: "/customer/list",
        submenuOpen: false,
        privilege: Privileges.ClientView,
      },
      {
        title: "Policies",
        /* Matches the page's own title. */
        topBarTitle: "Policy Report",
        icon: <AddModeratorIcon />,
        path: "/policy-list",
        submenuOpen: false,
        privilege: Privileges.PoliciesView,
      },
      {
        title: "Report",
        /* "Report List" named nothing. The screen reports coverage, ownership
           and beneficiaries across policies, and now says so. */
        topBarTitle: "Coverage Report",
        icon: <AssignmentIcon />,
        path: "/policy-scenarios/list",
        submenuOpen: false,
        privilege: Privileges.CoverageView,
      },
      {
        title: "Meeting",
        topBarTitle: "Meeting List",
        icon: <GroupsIcon />,
        path: "/client/meeting",
        submenuOpen: false,
        privilege: Privileges.ClientView,
      },
      {
        title: "Task",
        topBarTitle: "Task List",
        icon: <AddTaskIcon />,
        path: "/client/task",
        submenuOpen: false,
        privilege: Privileges.ClientView,
      },
      {
        title: "ToDo",
        topBarTitle: "ToDo List",
        icon: <PlaylistAddCheckIcon />,
        path: "/conversations/list",
        submenuOpen: false,
        privilege: Privileges.ToDoView,
      },
      {
        title: "Newsletter",
        topBarTitle: "Newsletter",
        icon: <MarkEmailUnreadIcon />,
        path: "/client/newsletters",
        submenuOpen: false,
        privilege: Privileges.NewslettersView,
      },
      {
        title: "Workshop",
        topBarTitle: "Workshop",
        icon: <HomeRepairServiceIcon />,
        path: "/workshop/list",
        submenuOpen: false,
        privilege: Privileges.WorkshopView,
      },
      {
        /* The screen this opens is titled Client Report and its breadcrumb reads
           Reports / Client Report; the topbar used to announce it as "Policy
           Report Generate", which named neither the page nor any control on it.
           Display text only — the path, the privilege and the route behaviour
           are untouched. */
        title: "Policy Report",
        topBarTitle: "Client Report",
        icon: <PictureAsPdfIcon />,
        path: "/client/report/generate",
        submenuOpen: false,
        privilege: Privileges.ClientView,
      },
    ],
  },

  {
    comomTitle: "Other",
    menuList: [
      // {
      //   title: "Products",
      //   topBarTitle: "Products List",
      //   icon: <PolicyIcon />,
      //   path: "/policy/list",
      //   submenuOpen: false,
      //   privilege: Privileges.PoliciesView,
      // },
      // {
      //   title: "Covergae Type",
      //   topBarTitle: "Covergae Type List",
      //   icon: <CategoryIcon />,
      //   path: "/category/list",
      //   submenuOpen: false,
      //   privilege: Privileges.CoverageView,
      // },
      {
        title: "Dropdown List",
        topBarTitle: "Dropdown List",
        icon: <ArrowDropDownCircleOutlinedIcon />,
        path: "/dropdown",
        submenuOpen: true,
        privilege: Privileges.PoliciesView,
        submenus: [
          {
            title: "Products",
            topBarTitle: "Products List",
            icon: <PolicyIcon />,
            path: "/policy/list",
            privilege: Privileges.PoliciesView,
          },
          {
            title: "Covergae Type",
            topBarTitle: "Covergae Type List",
            icon: <CategoryIcon />,
            path: "/category/list",
            privilege: Privileges.CoverageView,
          },
          {
            topBarTitle: "Insurance Company",
            title: "Insurance Company",
            icon: <MenuIcon />,
            path: "/brand/list",
            privilege: Privileges.InsuranceCompanyView,
          },
          {
            topBarTitle: "Client Type",
            title: "Client Type",
            icon: <MenuIcon />,
            path: "/client_type/list",
            privilege: Privileges.ClientTypeView,
          },
        ],
      },
      {
        title: "Setting",
        topBarTitle: "Setting",
        icon: <SettingsOutlinedIcon />,
        path: "/looping",
        submenuOpen: true,
        privilege: Privileges.SettingView,
        submenus: [
          {
            topBarTitle: "User",
            title: "User",
            icon: <MenuIcon />,
            path: "/user/list",
            privilege: Privileges.UserView,
          },
          {
            topBarTitle: "User Role",
            title: "User Role",
            icon: <MenuIcon />,
            path: "/user/role/list",
            privilege: Privileges.UserView,
          },
          {
            topBarTitle: "Privilege",
            title: "Privilege",
            icon: <MenuIcon />,
            path: "/user/privilege/list",
            privilege: Privileges.UserView,
          },
          {
            topBarTitle: "Branch List",
            title: "Branch",
            icon: <MenuIcon />,
            path: "/branch/list",
            privilege: Privileges.BranchView,
          },
          {
            topBarTitle: "Client Report Setting",
            title: "Client Report Setting",
            icon: <MenuIcon />,
            path: "/client/report/setting",
            privilege: Privileges.CompanyView,
          },
          {
            topBarTitle: "Company",
            title: "Company",
            icon: <MenuIcon />,
            path: "/setting",
            privilege: Privileges.CompanyView,
          },
          {
            topBarTitle: "Templates",
            title: "Templates",
            icon: <EmailIcon />,
            path: "/email/setting/list",
            privilege: Privileges.EmailView,
          },
          {
            topBarTitle: "Newsletter",
            title: "Newsletter",
            icon: <MarkEmailUnreadIcon />,
            path: "/client/newsletters/list",
            privilege: Privileges.NewslettersView,
          },
          {
            topBarTitle: "Theme Color",
            title: "Theme Color",
            icon: <MenuIcon />,
            path: "/theme-color",
            privilege: Privileges.ThemeView,
          },
        ],
      },
      {
        title: "Documentation",
        topBarTitle: "Documentation",
        icon: <MenuBookIcon />,
        path: "/documentation",
        submenuOpen: false,
        privilege: PUBLIC_MENU_ITEM,
        matchPrefix: true,
      },
    ],
  },
  {
    comomTitle: "Staff",
    menuList: [
      // {
      //   title: "Punch Details",
      //   topBarTitle: "Punch Details List",
      //   icon: <PunchClockIcon />,
      //   path: "/punch/list",
      //   submenuOpen: false,
      //   privilege: Privileges.PunchDetailsView,
      // },
      // {
      //   title: "Schedule",
      //   topBarTitle: "Schedule & Reschedule List",
      //   icon: <EditCalendarIcon />,
      //   path: "/Schedule/list/one-day",
      //   submenuOpen: false,
      //   privilege: Privileges.ScheduleView,
      // },
      // {
      //   topBarTitle: "Reschedule List",
      //   title: "Reschedule",
      //   icon: <EditCalendarIcon />,
      //   path: "/re-Schedule/list",
      //   privilege: Privileges.ScheduleView,
      // },
      // {
      //   title: "Clock In/Out",
      //   topBarTitle: "Clock In/Out List",
      //   icon: <ChecklistRtlIcon />,
      //   path: "/schedule/list",
      //   submenuOpen: false,
      //   privilege: Privileges.ScheduleView,
      // },
      // {
      //   title: "Payroll",
      //   topBarTitle: "Payroll List",
      //   icon: <ListAltIcon />,
      //   path: "/payroll/list",
      //   submenuOpen: false,
      //   privilege: Privileges.PayrollView,
      // },
      {
        topBarTitle: "Staff List",
        title: "Staff",
        icon: <Groups2Icon />,
        path: "/team/list",
        privilege: Privileges.StaffView,
      },
      {
        title: "Additional",
        topBarTitle: "Position/Department",
        icon: <AddIcon />,
        path: "/sc/othe",
        submenuOpen: true,
        privilege: Privileges.OtherView,
        submenus: [
          {
            topBarTitle: "Department List",
            title: "Department",
            icon: <MenuIcon />,
            path: "/department/list",
            privilege: Privileges.DepartmentView,
          },
          {
            topBarTitle: "Position List",
            title: "Position",
            icon: <MenuIcon />,
            path: "/position/list",
            privilege: Privileges.PositionView,
          },
        ],
      },
    ],
  },
];

export default function MiniDrawer({
  children,
}: {
  children: React.ReactNode;
}) {
  const theme = useTheme();
  const classes = useStyles();
  const navigate = useNavigate();
  const location = useLocation();
  const { userHasRight } = useUser();
  const [mobileDrawerOpen, setMobileDrawerOpen] = React.useState(false);
  const isMobile = useMediaQuery(theme.breakpoints.down("lg"));
  const [open, setOpen] = React.useState(true);

  const [notificationPopUp, setNotificationPopUp] =
    React.useState<HTMLElement | null>(null);
  const { mode, toggleTheme } = useThemeContext();
  const [profilePopUp, setProfilePopUp] = useState<HTMLElement | null>(null);
  const openProfilePopUp = Boolean(profilePopUp);
  const openNotificationPopUp = Boolean(notificationPopUp);

  const [currentMenuName, setCurrentMenuName] = React.useState("");
  const [hoveredMenuName, setHoveredMenuName] = React.useState("");

  /**
   * Hovering a menu item now also starts downloading that route's chunk.
   *
   * Since `Drawer/Routes.tsx` moved to `React.lazy`, the first visit to a
   * route pays for a chunk fetch before the page can mount. The pointer
   * usually rests on a menu item for a couple of hundred milliseconds before
   * the click lands, which is enough to have the chunk in memory by the time
   * it is needed — so the split costs nothing on the paths users actually
   * take.
   *
   * `prefetchRoute` fetches code only, never data, dedupes per path and backs
   * off on metered connections, so this is safe to fire on every hover. The
   * highlight state it replaced is set exactly as before.
   */
  const handleMenuHover = React.useCallback((path: string) => {
    setHoveredMenuName(path);
    prefetchRoute(path);
  }, []);

  /* Warm the two or three routes essentially every session opens, once, after
     the shell has mounted and the browser is idle. */
  React.useEffect(() => prefetchCoreRoutes(), []);
  const [expandMenu, setExpandMenu] = React.useState<string>("");
  /* Still derived, deliberately not rendered. The topbar stopped printing the
     page title — each screen's own header carries it — but the whole
     path->title map (`findTopBarTitle`, the `topBarTitle` entries in
     `MainMenuList`) is left intact rather than deleted across sixty menu
     entries, so the title can be put back on any bar without rebuilding it. */
  const [topBarTitle, setTopBarTitle] = useState("");
  // Hover is handled in CSS now; the setter stays because the row handlers and
  // the submenu expand/collapse logic still call it.
  const [, setHoveredSubmenu] = React.useState("");
  const [selectedSubmenu, setSelectedSubmenu] = React.useState("");
  const { currentMenuNameFullScreen } = useApp();
  const [openText, setOpenText] = React.useState(false);

  /**
   * Styling for a top-level sidebar item. The active item is a softly rounded
   * filled pill rather than a hairline rule; hover is a lighter wash of the
   * same treatment. Which item is active is decided exactly as before — by
   * currentMenuName, or by an open submenu whose path sits under this one.
   */
  const mainMenuItemSx = React.useCallback(
    (path: string) => {
      const active =
        currentMenuName === path || (!!selectedSubmenu && selectedSubmenu.startsWith(path));
      /* `accent` drives the surface, the marker and the icon; the LABEL of an
         active item goes near-white. Tinting the text the same colour as its
         own background wash is what made the previous active state read as
         low-contrast rather than as selected. */
      const accent = theme.palette.mainMenuNav.hoverColorNavBg;
      const activeText = "#FFFFFF";
      const restText = theme.palette.topbarButton.drawerMenuText;

      return {
        position: "relative",
        borderRadius: "12px",
        mx: 1.25,
        my: 0.25,
        py: 0.9,
        minHeight: 46,
        overflow: "hidden",
        /* The active item is a layered pill, not a flat rectangle: a gradient
           wash that fades to the right, a 1px inner highlight along the top
           edge, and a short accent bar on the left. */
        backgroundColor: "transparent",
        backgroundImage: active
          ? `linear-gradient(90deg, ${alpha(accent, 0.24)} 0%, ${alpha(accent, 0.08)} 100%)`
          : "none",
        boxShadow: active ? `inset 0 1px 0 ${alpha("#ffffff", 0.16)}` : "none",
        transition: theme.transitions.create(
          ["background-color", "background-image", "color", "box-shadow"],
          { duration: 180 }
        ),
        "&::before": {
          content: '""',
          position: "absolute",
          left: 0,
          top: "50%",
          transform: "translateY(-50%)",
          width: "3px",
          height: active ? "22px" : "0px",
          borderRadius: "0 3px 3px 0",
          backgroundColor: accent,
          transition: theme.transitions.create("height", { duration: 180 }),
        },
        "&:hover": {
          backgroundColor: alpha("#ffffff", active ? 0.04 : 0.06),
          "& .MuiListItemIcon-root, & .MuiTypography-root": {
            color: activeText,
            opacity: 1,
          },
        },
        "&:focus-visible": {
          outline: `2px solid ${alpha(accent, 0.8)}`,
          outlineOffset: -2,
        },
        "@media (prefers-reduced-motion: reduce)": {
          transition: "none",
          "&::before": { transition: "none" },
        },
        "& .MuiListItemIcon-root": {
          color: active ? accent : restText,
          opacity: active ? 1 : 0.7,
          transition: theme.transitions.create(["color", "opacity"], { duration: 160 }),
        },
        "& .MuiTypography-root": {
          fontSize: "13.5px",
          letterSpacing: "-0.005em",
          color: active ? activeText : restText,
          opacity: active ? 1 : 0.82,
          fontWeight: active ? 650 : 500,
          transition: theme.transitions.create(["color", "opacity"], { duration: 160 }),
        },
      };
    },
    [currentMenuName, selectedSubmenu, theme]
  );

  /** Nested item under an expanded section — same language, quieter. */
  const subMenuItemSx = React.useCallback(
    (path: string) => {
      const active = currentMenuName === path;
      const accent = theme.palette.mainMenuNav.hoverColorNavBg;
      const activeText = "#FFFFFF";
      const restText = theme.palette.topbarButton.drawerMenuText;

      return {
        position: "relative",
        pl: "56px",
        ml: 1,
        mr: 1,
        my: 0.15,
        py: 0.6,
        minHeight: 36,
        borderRadius: "8px",
        backgroundColor: active ? alpha(accent, 0.14) : "transparent",
        transition: theme.transitions.create(["background-color"], { duration: 160 }),
        /* A hairline guide down the left of the nested group, so a submenu
           reads as belonging to its parent rather than as a second list. */
        "&::before": {
          content: '""',
          position: "absolute",
          left: "34px",
          top: 0,
          bottom: 0,
          width: "1px",
          backgroundColor: alpha("#ffffff", 0.1),
        },
        "&::after": {
          content: '""',
          position: "absolute",
          left: "32px",
          top: "50%",
          transform: "translateY(-50%)",
          width: "5px",
          height: "5px",
          borderRadius: "50%",
          backgroundColor: active ? accent : "transparent",
          transition: theme.transitions.create(["background-color"], { duration: 160 }),
        },
        "&:hover": {
          backgroundColor: alpha("#ffffff", active ? 0.06 : 0.05),
          "& .MuiListItemIcon-root, & .MuiTypography-root": { color: activeText, opacity: 1 },
        },
        "&:focus-visible": {
          outline: `2px solid ${alpha(accent, 0.8)}`,
          outlineOffset: -2,
        },
        "& .MuiTypography-root": {
          fontSize: "13px",
          color: active ? activeText : restText,
          opacity: active ? 1 : 0.72,
          fontWeight: active ? 620 : 500,
          transition: theme.transitions.create(["color", "opacity"], { duration: 160 }),
        },
      };
    },
    [currentMenuName, theme]
  );

  /**
   * Menu visibility: a privilege check, except for entries flagged
   * PUBLIC_MENU_ITEM which every signed-in user sees.
   */
  const canSeeMenuItem = React.useCallback(
    (item: { privilege: string }) =>
      item.privilege === PUBLIC_MENU_ITEM || userHasRight(item.privilege),
    [userHasRight]
  );

  const { data } = useGetUserQuery();

  const {
    data: noificationData,
    isLoading,
    isError,
    refetch,
  } = useGetConversationsNotificationQuery(
    { searchText: "", staffId: "", id: "" },
    {
      pollingInterval: 120000,
      /* The notification badge lives in the top bar, so this poll runs on
         every authenticated page for as long as the tab is open. Suspending
         it while the document is unfocused costs nothing — RTK refetches
         immediately on refocus, so the badge is already correct by the time
         the user can read it. */
      skipPollingIfUnfocused: true,
    }
  );

  const {
    data: birthdayData,
    isLoading: birthdayIsLoading,
    isError: birthdayIsError,
  } = useGetAllBirthdayDhashboardQuery({
    searchText: "",
    policyCustomerId: "",
    id: "",
  });

  const { data: allclientData, isLoading: allcilentIsLoading } =
    useGetCustomerQuery({
      searchText: "",
      id: "",
    });

  const userRole = React.useMemo(() => {
    if (data?.data) {
      const userData = data.data as IUserInfo;
      return userData.user_role_name;
    }
    return "";
  }, [data]);

  const username = React.useMemo(() => {
    if (data?.data) {
      const userData = data.data as IUserInfo;
      return userData.username;
    }
    return "";
  }, [data]);

  const branchName = React.useMemo(() => {
    if (data?.data) {
      const userData = data.data as IUserInfo;
      return userData.branch;
    }
    return "";
  }, [data]);

  const staffName = React.useMemo(() => {
    if (data?.data) {
      const userData = data.data as IUserInfo;
      return userData.staff;
    }
    return "";
  }, [data]);

  const allcliendList = React.useMemo(() => {
    return (allclientData?.data ?? []) as ICustomer[];
  }, [allclientData?.data]);

  const notificationList: IToDo[] = Array.isArray(noificationData?.data)
    ? (noificationData?.data as IToDo[])
    : [];

  // Get today's birthday count safely
  const birthdayCount = birthdayData?.todaysBirthdaysCount ?? 0;
  const noteCountToday = noificationData?.todayNotecount ?? 0;
  const meetingCountToday = noificationData?.meetingCount ?? 0;

  // Calculate unread notifications from your notification list
  const readCount = Array.isArray(notificationList)
    ? notificationList.reduce(
        (total, notif) => total + (notif.unread_count || 0),
        0
      )
    : 0;

  // Total unread count (notifications + birthdays)
  // const unreadCount =
  //   birthdayCount + readCount + noteCountToday + meetingCountToday;

  const totalCountup = noificationData?.totalCount ?? 0;

  const unreadCount = totalCountup + readCount;

  // const todaysBirthdaysList: ICustomer[] = Array.isArray(birthdayData?.todaysBirthdays)
  // ? (birthdayData?.todaysBirthdays as ICustomer[])
  // : [];

  // const unreadCount =
  //   notificationList.reduce(
  //     (total, notif) => total + (notif.unread_count || 0),
  //     0
  //   ) +(birthdayData?.todaysBirthdaysCount ?? 0);

  const clientMap = useMemo(() => {
    const map = new Map();
    allcliendList?.forEach((category) => {
      map.set(
        category.id,
        toProperCase(category.customerFirstName || "") +
          " " +
          toProperCase(category.customerLastName || "")
      );
    });
    return map;
  }, [allcliendList]);

  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, [currentMenuName]);
  // console.log(staffName);

  // React.useEffect(() => {
  //   for (const mainMenu of MainMenuList) {
  //     for (const menu of mainMenu.menuList || []) {
  //       if (menu.path === location.pathname) {
  //         setCurrentMenuName(menu.path);
  //         setSelectedSubmenu("");
  //         setExpandMenu(menu.title);
  //       }

  //       for (const submenu of menu.submenus || []) {
  //         if (submenu.path === location.pathname) {
  //           setSelectedSubmenu(submenu.path);
  //           setExpandMenu(menu.title);
  //         }
  //       }
  //     }
  //   }
  // }, [location.pathname]);

  React.useEffect(() => {
    let found = false;
    for (const mainMenu of MainMenuList) {
      for (const menu of mainMenu.menuList || []) {
        // matchPrefix keeps deep links (/documentation/clients) highlighted.
        if (
          menu.path === location.pathname ||
          (menu.matchPrefix && location.pathname.startsWith(`${menu.path}/`))
        ) {
          setCurrentMenuName(menu.path);
          setSelectedSubmenu("");
          setExpandMenu(menu.title);
          found = true;
        }

        for (const submenu of menu.submenus || []) {
          if (submenu.path === location.pathname) {
            setSelectedSubmenu(submenu.path);
            setExpandMenu(menu.title);
            setHoveredSubmenu(submenu.path);
            found = true;
          }
        }

        if (found) break;
      }
      if (found) break;
    }
  }, [location.pathname]);

  React.useEffect(() => {
    const findTopBarTitle = (): string => {
      // Check custom routes first

      if (location.pathname.startsWith("/product-history/")) {
        return "Product Details";
      }
      if (location.pathname.startsWith("/department/create")) {
        return "Create Department";
      }
      if (location.pathname.startsWith("/store/create")) {
        return "Create Store";
      }
      if (location.pathname.startsWith("/category/create")) {
        return "Create Category";
      }
      if (location.pathname.startsWith("/product/create")) {
        return "Create Items";
      }
      if (location.pathname.startsWith("/branch/create")) {
        return "Create Branch";
      }
      if (location.pathname.startsWith("/branch/edit/")) {
        return "Edit Branch";
      }
      if (location.pathname.startsWith("/printer/create")) {
        return "Create Printer ";
      }
      if (location.pathname.startsWith("/tax/create")) {
        return "Create Tax";
      }
      if (location.pathname.startsWith("/user/privilege/create")) {
        return "Create Privilege";
      }
      if (location.pathname.startsWith("/user/role/create")) {
        return "Create User Role";
      }
      if (location.pathname.startsWith("/user/create")) {
        return "Create User";
      }
      if (location.pathname.startsWith("/main/item/view/")) {
        return "Main Item view";
      }
      if (location.pathname.startsWith("/main/item/create")) {
        return "Create Main Item";
      }
      if (location.pathname.startsWith("/tag/create")) {
        return "Create Tag";
      }
      if (location.pathname.startsWith("/brand/create")) {
        return "Create Brand";
      }
      if (location.pathname.startsWith("/order/list/create")) {
        return "Create Order List";
      }
      if (location.pathname.startsWith("/order/list/edit")) {
        return "Edit Order List";
      }
      if (location.pathname.startsWith("/team/create")) {
        return "Create Staff";
      }
      if (location.pathname.startsWith("/team-history/")) {
        return "View Staff";
      }
      if (location.pathname.startsWith("/re-Schedule/create?date=")) {
        return "Create Reschedule ";
      }
      if (location.pathname.startsWith("/attendance/weekly/report")) {
        return "Schedule Report";
      }
      if (location.pathname.startsWith("/re-Schedule/create")) {
        return "Create Reschedule ";
      }
      if (location.pathname.startsWith("/re-Schedule/list")) {
        return "Reschedule List";
      }
      if (location.pathname.startsWith("/payroll/generate")) {
        return "Payroll Generate";
      }
      if (location.pathname.startsWith("/payroll/list/edit/")) {
        return "Payroll Edit";
      }
      if (location.pathname.startsWith("/position/create")) {
        return "Position Create";
      }

      if (location.pathname.startsWith("/customer-history/")) {
        return "Client Details";
      }
      if (location.pathname.startsWith("/customer-deals/")) {
        return "Deals";
      }
      if (location.pathname.startsWith("/policy-history/")) {
        return "policy Details";
      }
      if (
        location.pathname.startsWith(
          "/profile/customer/:customerId/policy/:policyId"
        )
      ) {
        return "Profile";
      }
      if (location.pathname.startsWith("/profile/customer/")) {
        return "Profile";
      }

      if (location.pathname.startsWith("/looping/create")) {
        return "Create Looping";
      }
      if (location.pathname.startsWith("/coursing/create")) {
        return "Create Coursing";
      }
      if (location.pathname.startsWith("/brand/create")) {
        return "Create Insurance Company";
      }
      if (location.pathname.startsWith("/tag/create")) {
        return "Create Product Tag";
      }
      if (location.pathname.startsWith("/tax/create")) {
        return "Create Tax";
      }
      if (location.pathname.startsWith("/printer/create")) {
        return "Create Printer";
      }
      if (location.pathname.startsWith("/customer/create")) {
        return "Create Client";
      }
      if (location.pathname.startsWith("/policy/create")) {
        return "Create Policy";
      }
      if (location.pathname.startsWith("/category/create")) {
        return "Create Coverage";
      }
      if (location.pathname.startsWith("/deal/")) {
        return "Deal Edit";
      }
      if (location.pathname.startsWith("/summary-report/")) {
        return "Summary Report";
      }
      if (location.pathname.startsWith("/summary/pdf/")) {
        return "Generate Pdf";
      }
      if (location.pathname.startsWith("/client/meeting/create")) {
        return "Create Meeting";
      }
      if (location.pathname.startsWith("/conversations/create")) {
        return "Create Conversations";
      }
      if (location.pathname.startsWith("/conversations/messages")) {
        return "Messages";
      }
      if (location.pathname.startsWith("/client/meeting/setting")) {
        return "Meeting Setting";
      }
      if (location.pathname.startsWith("/email/setting/create")) {
        return "Create Email Setting";
      }
      if (location.pathname.startsWith("/email/template/create")) {
        return "Manage Template";
      }
      if (location.pathname.startsWith("/newsletters/create")) {
        return "Create Newsletter";
      }
      if (location.pathname.startsWith("/client_type/create")) {
        return "Create Client Type";
      }
      if (location.pathname.startsWith("/client/newsletters/view")) {
        return "View Client Newsletter E-mail";
      }
      // if (location.pathname.startsWith("/client/newsletters/list")) {
      //   return "Newsletter List";
      // }
      if (location.pathname.startsWith("/client/newsletters/sms/view")) {
        return "View Client Newsletter Sms";
      }
      if (location.pathname.startsWith("/client/newsletters/sms/list")) {
        return "Client Newsletter Sms List";
      }
      if (location.pathname.startsWith("/client/task/create")) {
        return "Create Task";
      }
      if (location.pathname.startsWith("/client/task/setting")) {
        return "Task Setting";
      }
      if (location.pathname.startsWith("/workshop/create")) {
        return "Register Workshop";
      }
      if (location.pathname.startsWith("/workshop/history/")) {
        return "Workshop Record History";
      }
      if (location.pathname.startsWith("/workshop/newsletter/e-mail/history")) {
        return "Workshop E-mail History";
      }
      if (location.pathname.startsWith("/workshop/newsletter/e-mail/view/")) {
        return "Workshop E-mail Record View";
      }
      if (location.pathname.startsWith("/workshop/newsletter/e-mail")) {
        return "Sent Workshop E-mail";
      }
      if (location.pathname.startsWith("/client/newsletter/e-mail")) {
        return "Sent E-mail";
      }
      if (location.pathname.startsWith("/client/newsletter/sms")) {
        return "Sent Sms";
      }
      if (location.pathname.startsWith("/workshop/feedback/list")) {
        return "Workshop FeedBack History";
      }
      if (location.pathname.startsWith("/documentation")) {
        return "Documentation";
      }
      // Check MainMenuList for matching path
      for (const mainMenu of MainMenuList) {
        for (const menu of mainMenu.menuList || []) {
          if (menu.path === location.pathname) {
            return menu.topBarTitle;
          }

          for (const submenu of menu.submenus || []) {
            if (submenu.path === location.pathname) {
              return submenu.topBarTitle || "";
            }
          }
        }
      }

      // Default title if no matches are found
      return "";
    };

    setTopBarTitle(findTopBarTitle());
  }, [location.pathname]);

  const handleDrawerToggle = () => {
    setOpen(!open);
    setExpandMenu("");
  };

  const handleMobileDrawerToggle = () => {
    setMobileDrawerOpen(!mobileDrawerOpen);
  };

  const handleMobileDrawerClose = () => {
    setMobileDrawerOpen(false);
  };

  const handleClickNotificationPopUp = (
    event: React.MouseEvent<HTMLElement>
  ) => {
    setNotificationPopUp(event.currentTarget);
  };

  const handleClickProfilePopUp = (event: React.MouseEvent<HTMLElement>) => {
    setProfilePopUp(event.currentTarget);
  };

  const handleCloseProfilePopUp = () => {
    setProfilePopUp(null);
  };

  const handleCloseNotificationPopUp = () => {
    setNotificationPopUp(null);
  };

  const handleImgClick = () => {
    navigate("/dashboard");
  };

  const handleMainMenuItemClick = (ml: menuList) => {
    if (ml.submenus && ml.submenus.length > 0) {
      setExpandMenu(ml.title === expandMenu ? "" : ml.title);
    } else if (ml.path) {
      setCurrentMenuName(ml.path);
      setSelectedSubmenu("");
      navigate(ml.path);
      setMobileDrawerOpen(false);
    }
    setTopBarTitle(ml.topBarTitle || "");
  };

  const handleSubmenuItemClicked = (submenu: SubmenuItem) => {
    setCurrentMenuName(submenu.path);
    setSelectedSubmenu(submenu.path);
    navigate(submenu.path);
    setTopBarTitle(submenu.topBarTitle || "");
    setMobileDrawerOpen(false);
  };

  const lastCustomerId = localStorage.getItem("lastCustomerId");

  return (
    <Box sx={{ display: "flex" }}>
      {!isMobile ? (
        <Box sx={{ display: "flex" }}>
          {currentMenuNameFullScreen === "/order/list/create" ||
          currentMenuNameFullScreen === "/order/list/edit/:id" ||
          currentMenuNameFullScreen ===
            "/customer/:customerId/policy/:policyNumber" ||
          currentMenuNameFullScreen === "/order/list/sentToManager/edit/:id" ? (
            <>
              <AppBarFullScreen
                position="fixed"
                className={classes.mobileTopbar}
              >
                <Toolbar className={classes.toolbar}>
                  {LogoMain && (
                    <img
                      src={LogoMain}
                      alt=""
                      style={{
                        width: "200px",
                        height: "45px",
                        display: "block",
                        cursor: "pointer",
                      }}
                      // onClick={handleImgClick}
                      onClick={handleMobileDrawerToggle}
                    />
                  )}
                  <IconButton
                    onClick={handleMobileDrawerToggle}
                    edge="start"
                    sx={{
                      ...(mobileDrawerOpen && { display: "none" }),
                      marginLeft: "24px",
                    }}
                    className={classes.topbarButton}
                  >
                    {mobileDrawerOpen ? (
                      <CloseIcon className={classes.topbarIcon} />
                    ) : (
                      <MenuIcon className={classes.topbarIcon} />
                    )}
                  </IconButton>
                  {/* The topbar no longer repeats the page title. Every
                      redesigned screen announces itself with its own header —
                      breadcrumb, icon tile and 27px title — so the topbar was
                      printing the same words a second time, 60px above them.
                      The element stays as the flex spacer that keeps the user
                      controls on the right. */}
                  <Box sx={{ width: "100%" }} />
                  <Grid
                    container
                    data-testid="user-content"
                    spacing={1}
                    alignItems="center"
                    justifyContent="flex-end"
                    sx={{ display: "flex" }}
                  >
                    <Grid item>
                      <Box display="flex" alignItems="center">
                        {lastCustomerId && openText && (
                          <Link
                            to={`/profile/customer/${lastCustomerId}`}
                            className={classes.iconLinkPropNormal}
                          >
                            <Typography className={classes.h4QuotoTopBarSearch}>
                              {clientMap.get(Number(lastCustomerId)) || ""}
                            </Typography>
                          </Link>
                        )}
                      </Box>
                    </Grid>
                    <Grid item>
                      {lastCustomerId && (
                        <Tooltip
                          title={
                            <>
                              <Typography variant="body2">
                                <strong>Recently Searched Client</strong>
                              </Typography>
                            </>
                          }
                          sx={{ fontSize: "14px" }}
                        >
                          <IconButton
                            aria-haspopup="true"
                            className={classes.topbarButton}
                            onClick={() => setOpenText((prev) => !prev)}
                          >
                            <PersonSearchRoundedIcon
                              className={classes.topbarIcon}
                            />
                          </IconButton>
                        </Tooltip>
                      )}
                      <IconButton
                        onClick={handleClickNotificationPopUp}
                        className={classes.topbarButton}
                        aria-haspopup="true"
                        aria-label={
                          unreadCount > 0 ? `Notifications, ${unreadCount} unread` : "Notifications"
                        }
                        title="Notifications"
                      >
                        <Badge
                          badgeContent={unreadCount > 0 ? unreadCount : null}
                          overlap="circular"
                          color="error"
                          max={99}
                          classes={{
                            badge:
                              unreadCount > 0 ? classes.badgePulse : undefined,
                          }}
                        >
                          <MdOutlineNotificationsNone
                            className={`${classes.topbarIcon} ${
                              unreadCount > 0 ? classes.bellActive : ""
                            }`}
                          />
                        </Badge>
                      </IconButton>
                      <IconButton
                        onClick={toggleTheme}
                        aria-label={
                          mode === "light" ? "Switch to dark mode" : "Switch to light mode"
                        }
                        title={mode === "light" ? "Switch to dark mode" : "Switch to light mode"}
                        className={classes.topbarButton}
                      >
                        {mode == "light" ? (
                          <MdDarkMode className={classes.topbarIcon} />
                        ) : (
                          <MdDarkMode className={classes.topbarIcon} />
                        )}
                      </IconButton>
                      <IconButton
                        onClick={handleClickProfilePopUp}
                        className={classes.topbarButton}
                        aria-haspopup="true"
                        aria-label="Account menu"
                        title="Account"
                      >
                        <AccountCircleRoundedIcon
                          className={classes.topbarIcon}
                        />
                      </IconButton>
                    </Grid>
                  </Grid>
                  <Profile
                    profile={profilePopUp}
                    onClose={handleCloseProfilePopUp}
                    open={openProfilePopUp}
                    username={username}
                    staffName={staffName}
                  />
                  <Notification
                    notification={notificationPopUp}
                    onClose={handleCloseNotificationPopUp}
                    open={openNotificationPopUp}
                    notificationData={notificationList}
                  />
                </Toolbar>

                <>
                  <MobileDrawer
                    open={mobileDrawerOpen}
                    onClose={handleMobileDrawerClose}
                  >
                    <DrawerHeader>
                      {open && (
                        <img
                          src={LogoMain}
                          alt="AttoDesk Login"
                          style={logoStyle}
                          onClick={handleImgClick}
                        />
                      )}
                      <IconButton
                        className={classes.topbarButton}
                        onClick={handleMobileDrawerClose}
                      >
                        {theme.direction === "rtl" ? (
                          <ChevronRightIcon className={classes.topbarIcon} />
                        ) : (
                          <ChevronLeftIcon className={classes.topbarIcon} />
                        )}
                      </IconButton>
                    </DrawerHeader>
                    <DrawerContent sx={{ padding: open ? 3 : 0 }}>
                      {MainMenuList.map((ml, index) => {
                        const hasPrivilege =
                          ml.menuList?.some((menuItem) =>
                            canSeeMenuItem(menuItem)
                          ) ||
                          ml.menuList?.some((menuItem) =>
                            menuItem.submenus?.some((submenu) =>
                              canSeeMenuItem(submenu)
                            )
                          );

                        return (
                          <React.Fragment key={index}>
                            {/* {index === 0 && open && (
                              <Grid
                                container
                                spacing={2}
                                justifyContent="center"
                                alignItems="center"
                                textAlign="center"
                              >
                                <List
                                  sx={{
                                    borderBottom: `1px solid ${theme.palette.background.default}`,
                                    paddingBottom: 2,
                                    paddingTop: 2,
                                    marginBottom: open ? 3 : 0,
                                  }}
                                >
                                  <ListItemButton>
                                    <ListItemIcon>
                                      <Avatar
                                        alt="Travis Howard"
                                        src={UserImg}
                                        className={classes.topbarIconProfileImg}
                                      />
                                    </ListItemIcon>
                                    <ListItemText
                                      className={classes.h4QuotoImg}
                                    >
                                      {username}
                                    </ListItemText>
                                  </ListItemButton>
                                </List>
                              </Grid>
                            )} */}
                            {index === 0 && open && (
                              <Box sx={{ height: 2 }}></Box>
                            )}
                            {open && hasPrivilege && (
                              <Box>
                                <Typography className={classes.menuTitle}>
                                  {ml.comomTitle}
                                </Typography>
                              </Box>
                            )}
                            {ml.menuList && (
                              <List
                                sx={
                                  {
                                    // borderBottom: "1px solid #878e9f",
                                    // paddingBottom: 5,
                                    // marginBottom: open ? 5 : 0,
                                    // borderBottom:
                                    //   open && hasPrivilege
                                    //     ? "1px solid #878e9f"
                                    //     : "none",
                                    // paddingBottom: open && hasPrivilege ? 5 : 0,
                                    // marginBottom: open && hasPrivilege ? 5 : 0,
                                  }
                                }
                              >
                                {ml.menuList
                                  .filter((menuList) =>
                                    canSeeMenuItem(menuList)
                                  ) // Filter by privilege
                                  .map((menuList) => (
                                    <ListItem
                                      button
                                      key={menuList.title}
                                      disablePadding
                                      sx={{
                                        display: "block",
                                      }}
                                      onMouseEnter={() =>
                                        handleMenuHover(menuList.path)
                                      }
                                      onMouseLeave={() =>
                                        setHoveredMenuName("")
                                      }
                                    >
                                      <ListItemButton
                                        component={
                                          menuList.submenus &&
                                          menuList.submenus.length > 0
                                            ? "div"
                                            : Link
                                        }
                                        to={
                                          menuList.submenus &&
                                          menuList.submenus.length > 0
                                            ? undefined
                                            : menuList.path
                                        }
                                        target="_self"
                                        onClick={() =>
                                          handleMainMenuItemClick(menuList)
                                        }
                                        sx={mainMenuItemSx(menuList.path)}
                                      >
                                        <ListItemIcon
                                          className={
                                            classes.listItemIcomMainMenu
                                          }
                                        >
                                          {menuList.icon as React.ReactNode}
                                        </ListItemIcon>
                                        <ListItemText
                                          className={classes.menuListItemText}
                                        >
                                          {menuList.title}
                                        </ListItemText>
                                        <ListItemIcon
                                          className={
                                            classes.listItemIcomMainMenu
                                          }
                                          sx={{
                                            display: "flex",
                                            textAlign: "end",
                                            justifyContent: "flex-end",
                                          }}
                                        >
                                          {menuList.submenus &&
                                            (expandMenu === menuList.title ? (
                                              <ExpandLessIcon
                                                sx={{
                                                  fontSize: "18px",
                                                  display: "flex",
                                                  textAlign: "end",
                                                  justifyContent: "flex-end",
                                                  "&:hover": {
                                                    color:
                                                      theme.palette.mainMenuNav
                                                        .hoverColorNavBg,
                                                  },
                                                  color:
                                                    selectedSubmenu?.startsWith(
                                                      menuList.path
                                                    ) ||
                                                    hoveredMenuName ===
                                                      menuList.path ||
                                                    currentMenuName ===
                                                      menuList.path
                                                      ? theme.palette
                                                          .mainMenuNav
                                                          .hoverColorNavBg
                                                      : currentMenuName ===
                                                        menuList.path
                                                      ? theme.palette
                                                          .mainMenuNav
                                                          .hoverColorNavBg
                                                      : theme.palette
                                                          .topbarButton
                                                          .drawerMenuText,
                                                  opacity:
                                                    selectedSubmenu?.startsWith(
                                                      menuList.path
                                                    ) ||
                                                    hoveredMenuName ===
                                                      menuList.path ||
                                                    currentMenuName ===
                                                      menuList.path
                                                      ? 1
                                                      : 0.6,
                                                }}
                                              />
                                            ) : (
                                              <ExpandMoreIcon
                                                sx={{
                                                  fontSize: "18px",
                                                  display: "flex",
                                                  textAlign: "end",
                                                  justifyContent: "flex-end",
                                                  "&:hover": {
                                                    color:
                                                      theme.palette.mainMenuNav
                                                        .hoverColorNavBg,
                                                  },
                                                  color:
                                                    selectedSubmenu?.startsWith(
                                                      menuList.path
                                                    ) ||
                                                    hoveredMenuName ===
                                                      menuList.path ||
                                                    currentMenuName ===
                                                      menuList.path
                                                      ? theme.palette
                                                          .mainMenuNav
                                                          .hoverColorNavBg
                                                      : currentMenuName ===
                                                        menuList.path
                                                      ? theme.palette
                                                          .mainMenuNav
                                                          .hoverColorNavBg
                                                      : theme.palette
                                                          .topbarButton
                                                          .drawerMenuText,
                                                  opacity:
                                                    selectedSubmenu?.startsWith(
                                                      menuList.path
                                                    ) ||
                                                    hoveredMenuName ===
                                                      menuList.path ||
                                                    currentMenuName ===
                                                      menuList.path
                                                      ? 1
                                                      : 0.6,
                                                }}
                                              />
                                            ))}
                                        </ListItemIcon>
                                      </ListItemButton>
                                      {menuList.submenus && (
                                        <Collapse
                                          in={expandMenu === menuList.title}
                                          timeout="auto"
                                          unmountOnExit
                                        >
                                          <List>
                                            {menuList.submenus
                                              .filter((submenu) =>
                                                canSeeMenuItem(submenu)
                                              )
                                              .map((submenu) => (
                                                <ListItem
                                                  disablePadding
                                                  key={submenu.title}
                                                  onMouseEnter={() =>
                                                    setHoveredSubmenu(
                                                      submenu.path
                                                    )
                                                  }
                                                  onMouseLeave={() =>
                                                    setHoveredSubmenu("")
                                                  }
                                                >
                                                  <ListItemButton
                                                    component={Link}
                                                    to={submenu.path}
                                                    target="_self"
                                                    onClick={() =>
                                                      handleSubmenuItemClicked(
                                                        submenu
                                                      )
                                                    }
                                                    sx={subMenuItemSx(submenu.path)}
                                                  >
                                                    <ListItemText
                                                      className={
                                                        classes.menuListItemText
                                                      }
                                                    >
                                                      <Typography>
                                                        {submenu.title}
                                                      </Typography>
                                                    </ListItemText>
                                                  </ListItemButton>
                                                </ListItem>
                                              ))}
                                          </List>
                                        </Collapse>
                                      )}
                                    </ListItem>
                                  ))}
                              </List>
                            )}
                          </React.Fragment>
                        );
                      })}
                    </DrawerContent>
                  </MobileDrawer>
                </>
              </AppBarFullScreen>
            </>
          ) : (
            <>
              <CssBaseline />
              <AppBar position="fixed" open={open} className={classes.topbar}>
                <Toolbar className={classes.toolbar}>
                  {/* Same as the mobile bar above: the page owns its title, the
                      topbar owns the account controls. Spacer only. */}
                  <Box sx={{ width: "100%" }} />
                  <Grid
                    container
                    data-testid="user-content"
                    spacing={1}
                    alignItems="center"
                    justifyContent="flex-end"
                    sx={{ display: "flex" }}
                  >
                    <Grid item>
                      <Box display="flex" alignItems="center">
                        {lastCustomerId && openText && (
                          <Link
                            to={`/profile/customer/${lastCustomerId}`}
                            className={classes.iconLinkPropNormal}
                          >
                            <Typography className={classes.h4QuotoTopBarSearch}>
                              {clientMap.get(Number(lastCustomerId)) || ""}
                            </Typography>
                          </Link>
                        )}
                      </Box>
                    </Grid>
                    <Grid item>
                      {lastCustomerId && (
                        <Tooltip
                          title={
                            <>
                              <Typography variant="body2">
                                <strong>Recently Searched Client</strong>
                              </Typography>
                            </>
                          }
                          sx={{ fontSize: "14px" }}
                        >
                          <IconButton
                            aria-haspopup="true"
                            className={classes.topbarButton}
                            onClick={() => setOpenText((prev) => !prev)}
                          >
                            <PersonSearchRoundedIcon
                              className={classes.topbarIcon}
                            />
                          </IconButton>
                        </Tooltip>
                      )}
                      <IconButton
                        onClick={handleClickNotificationPopUp}
                        className={classes.topbarButton}
                        aria-haspopup="true"
                        aria-label={
                          unreadCount > 0 ? `Notifications, ${unreadCount} unread` : "Notifications"
                        }
                        title="Notifications"
                      >
                        <Badge
                          badgeContent={unreadCount > 0 ? unreadCount : null}
                          overlap="circular"
                          color="error"
                          max={99}
                          classes={{
                            badge:
                              unreadCount > 0 ? classes.badgePulse : undefined,
                          }}
                        >
                          <MdOutlineNotificationsNone
                            className={`${classes.topbarIcon} ${
                              unreadCount > 0 ? classes.bellActive : ""
                            }`}
                          />
                        </Badge>
                      </IconButton>
                      <IconButton
                        onClick={toggleTheme}
                        aria-label={
                          mode === "light" ? "Switch to dark mode" : "Switch to light mode"
                        }
                        title={mode === "light" ? "Switch to dark mode" : "Switch to light mode"}
                        className={classes.topbarButton}
                      >
                        {mode == "light" ? (
                          <MdDarkMode className={classes.topbarIcon} />
                        ) : (
                          <MdDarkMode className={classes.topbarIcon} />
                        )}
                      </IconButton>
                      <IconButton
                        onClick={handleClickProfilePopUp}
                        className={classes.topbarButton}
                        aria-haspopup="true"
                        aria-label="Account menu"
                        title="Account"
                      >
                        <AccountCircleRoundedIcon
                          className={classes.topbarIcon}
                        />
                      </IconButton>
                    </Grid>
                  </Grid>
                  <Profile
                    profile={profilePopUp}
                    onClose={handleCloseProfilePopUp}
                    open={openProfilePopUp}
                    username={username}
                    staffName={staffName}
                  />
                  <Notification
                    notification={notificationPopUp}
                    onClose={handleCloseNotificationPopUp}
                    open={openNotificationPopUp}
                    notificationData={notificationList}
                  />
                </Toolbar>
              </AppBar>
              <IsNotMobileDrawer variant="permanent" open={open}>
                <DrawerHeader>
                  {open ? (
                    <img
                      src={LogoMain}
                      alt="AttoDesk Login"
                      style={logoStyle}
                      onClick={handleImgClick}
                    />
                  ) : (
                    ""
                  )}

                  <IconButton
                    className={classes.topbarButton}
                    onClick={handleDrawerToggle}
                  >
                    {open ? (
                      <ChevronRightIcon className={classes.topbarIcon} />
                    ) : (
                      <ChevronLeftIcon className={classes.topbarIcon} />
                    )}
                  </IconButton>
                </DrawerHeader>

                <DrawerContent sx={{ padding: open ? 1 : 0 }}>
                  {MainMenuList.map((ml, index) => {
                    const hasPrivilege =
                      ml.menuList?.some((menuItem) =>
                        canSeeMenuItem(menuItem)
                      ) ||
                      ml.menuList?.some((menuItem) =>
                        menuItem.submenus?.some((submenu) =>
                          canSeeMenuItem(submenu)
                        )
                      );

                    return (
                      <Grid>
                        <React.Fragment key={index}>
                          {/* {index === 0 && open && (
                            <Grid
                              container
                              spacing={2}
                              justifyContent="center"
                              alignItems="center"
                              textAlign="center"
                            >
                              <List
                                sx={{
                                  borderBottom: `1px solid ${theme.palette.background.default}`,
                                  paddingBottom: 2,
                                  paddingTop: 4,
                                  marginBottom: open ? 3 : 0,
                                }}
                              >
                                <ListItemButton>
                                  <ListItemIcon>
                                    <Avatar
                                      alt="Travis Howard"
                                      src={UserImg}
                                      className={classes.topbarIconProfileImg}
                                    />
                                  </ListItemIcon>
                                  <ListItemText className={classes.h4QuotoImg}>
                                    {username}
                                  </ListItemText>
                                </ListItemButton>
                              </List>
                            </Grid>
                          )} */}
                          {index === 0 && open && (
                            <Box sx={{ height: 2 }}></Box>
                          )}
                          {open && hasPrivilege && (
                            <Box>
                              <Typography className={classes.menuTitle}>
                                {ml.comomTitle}
                              </Typography>
                            </Box>
                          )}
                          {ml.menuList && (
                            <List
                              sx={
                                {
                                  // borderBottom: "1px solid #878e9f",
                                  // paddingBottom: 5,
                                  // marginBottom: open ? 5 : 0,
                                  // borderBottom:
                                  //   open && hasPrivilege
                                  //     ? `1px solid ${theme.palette.topbarButton.drawerMenuText}`
                                  //     : "none",
                                  // paddingBottom: open && hasPrivilege ? 5 : 0,
                                  // marginBottom: open && hasPrivilege ? 5 : 0,
                                }
                              }
                            >
                              {ml.menuList
                                .filter((menuItem) =>
                                  canSeeMenuItem(menuItem)
                                ) // Filter by privilege
                                .map((menuItem) => (
                                  <ListItem
                                    button
                                    key={menuItem.title}
                                    disablePadding
                                    sx={{
                                      display: "block",
                                    }}
                                    onMouseEnter={() =>
                                      handleMenuHover(menuItem.path)
                                    }
                                    onMouseLeave={() => setHoveredMenuName("")}
                                  >
                                    <ListItemButton
                                      // component={Link}
                                      // to={menuItem.path}
                                      component={
                                        menuItem.submenus &&
                                        menuItem.submenus.length > 0
                                          ? "div"
                                          : Link
                                      }
                                      to={
                                        menuItem.submenus &&
                                        menuItem.submenus.length > 0
                                          ? undefined
                                          : menuItem.path
                                      }
                                      target="_self"
                                      onClick={() =>
                                        handleMainMenuItemClick(menuItem)
                                      }
                                      sx={mainMenuItemSx(menuItem.path)}
                                    >
                                      <ListItemIcon
                                        className={classes.listItemIcomMainMenu}
                                      >
                                        {menuItem.icon as React.ReactNode}
                                      </ListItemIcon>
                                      <ListItemText
                                        className={classes.menuListItemText}
                                      >
                                        {menuItem.title}
                                      </ListItemText>
                                      <ListItemIcon
                                        className={classes.listItemIcomMainMenu}
                                        sx={{
                                          display: "flex",
                                          textAlign: "end",
                                          justifyContent: "flex-end",
                                        }}
                                      >
                                        {menuItem.submenus &&
                                          (expandMenu === menuItem.title ? (
                                            <ExpandLessIcon
                                              sx={{
                                                fontSize: "18px",
                                                display: "flex",
                                                textAlign: "end",
                                                justifyContent: "flex-end",
                                                "&:hover": {
                                                  color:
                                                    theme.palette.mainMenuNav
                                                      .hoverColorNavBg,
                                                },
                                                color:
                                                  selectedSubmenu?.startsWith(
                                                    menuItem.path
                                                  ) ||
                                                  hoveredMenuName ===
                                                    menuItem.path ||
                                                  currentMenuName ===
                                                    menuItem.path
                                                    ? theme.palette.mainMenuNav
                                                        .hoverColorNavBg
                                                    : currentMenuName ===
                                                      menuItem.path
                                                    ? theme.palette.mainMenuNav
                                                        .hoverColorNavBg
                                                    : theme.palette.topbarButton
                                                        .drawerMenuText,
                                                opacity:
                                                  selectedSubmenu?.startsWith(
                                                    menuItem.path
                                                  ) ||
                                                  hoveredMenuName ===
                                                    menuItem.path ||
                                                  currentMenuName ===
                                                    menuItem.path
                                                    ? 1
                                                    : 0.6,
                                              }}
                                            />
                                          ) : (
                                            <ExpandMoreIcon
                                              sx={{
                                                fontSize: "18px",
                                                display: "flex",
                                                textAlign: "end",
                                                justifyContent: "flex-end",
                                                "&:hover": {
                                                  color:
                                                    theme.palette.mainMenuNav
                                                      .hoverColorNavBg,
                                                },
                                                color:
                                                  selectedSubmenu?.startsWith(
                                                    menuItem.path
                                                  ) ||
                                                  hoveredMenuName ===
                                                    menuItem.path ||
                                                  currentMenuName ===
                                                    menuItem.path
                                                    ? theme.palette.mainMenuNav
                                                        .hoverColorNavBg
                                                    : currentMenuName ===
                                                      menuItem.path
                                                    ? theme.palette.mainMenuNav
                                                        .hoverColorNavBg
                                                    : theme.palette.topbarButton
                                                        .drawerMenuText,
                                                opacity:
                                                  selectedSubmenu?.startsWith(
                                                    menuItem.path
                                                  ) ||
                                                  hoveredMenuName ===
                                                    menuItem.path ||
                                                  currentMenuName ===
                                                    menuItem.path
                                                    ? 1
                                                    : 0.6,
                                              }}
                                            />
                                          ))}
                                      </ListItemIcon>
                                    </ListItemButton>
                                    {menuItem.submenus && (
                                      <Collapse
                                        in={expandMenu === menuItem.title}
                                        timeout="auto"
                                        unmountOnExit
                                      >
                                        <List>
                                          {menuItem.submenus
                                            .filter((submenu) =>
                                              canSeeMenuItem(submenu)
                                            )
                                            .map((submenu) => (
                                              <ListItem
                                                disablePadding
                                                key={submenu.title}
                                                onMouseEnter={() =>
                                                  setHoveredSubmenu(
                                                    submenu.path
                                                  )
                                                }
                                                onMouseLeave={() =>
                                                  setHoveredSubmenu("")
                                                }
                                              >
                                                <ListItemButton
                                                  component={Link}
                                                  to={submenu.path}
                                                  target="_self"
                                                  onClick={() =>
                                                    handleSubmenuItemClicked(
                                                      submenu
                                                    )
                                                  }
                                                  sx={subMenuItemSx(submenu.path)}
                                                >
                                                  <ListItemText
                                                    className={
                                                      classes.menuListItemText
                                                    }
                                                  >
                                                    <Typography>
                                                      {submenu.title}
                                                    </Typography>
                                                  </ListItemText>
                                                </ListItemButton>
                                              </ListItem>
                                            ))}
                                        </List>
                                      </Collapse>
                                    )}
                                  </ListItem>
                                ))}
                            </List>
                          )}
                        </React.Fragment>
                      </Grid>
                    );
                  })}
                </DrawerContent>
              </IsNotMobileDrawer>
            </>
          )}
        </Box>
      ) : (
        <Box sx={{ display: "flex" }}>
          <AppBar position="fixed" className={classes.mobileTopbar}>
            <Toolbar className={classes.toolbar}>
              <Grid
                container
                justifyContent="space-between"
                sx={{ width: "100%" }}
                alignItems="center"
              >
                <Grid item md={1} sm={1}>
                  <IconButton
                    onClick={handleMobileDrawerToggle}
                    edge="start"
                    sx={{
                      ...(mobileDrawerOpen && { display: "none" }),
                    }}
                    className={classes.topbarButton}
                  >
                    {mobileDrawerOpen ? (
                      <CloseIcon className={classes.topbarIcon} />
                    ) : (
                      <MenuIcon className={classes.topbarIcon} />
                    )}
                  </IconButton>
                </Grid>
                {/* <Grid item md={2} sm={2}>
                  {lastCustomerId && (
                    <Link
                      to={`/profile/customer/${lastCustomerId}`}
                      className={classes.iconLinkPropNormal}
                    >
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "8px",
                        }}
                      >
                        <PersonSearchRoundedIcon
                          fontSize="medium"
                          color="primary"
                        />
                        <Typography
                          width={"100%"}
                          className={classes.h4QuotoTopBarSearch}
                        >
                          {clientMap.get(Number(lastCustomerId)) || ""}
                        </Typography>
                      </div>
                    </Link>
                  )}
                </Grid> */}
                <Grid
                  item
                  md={11}
                  sm={11}
                  justifyContent="end"
                  alignItems="end"
                >
                  <Grid
                    container
                    data-testid="user-content"
                    spacing={1}
                    alignItems="center"
                    justifyContent="flex-end"
                    sx={{ display: "flex" }}
                  >
                    <Grid item>
                      {lastCustomerId && (
                        <Tooltip
                          title={
                            <>
                              <Typography variant="body2">
                                <strong>Recently Searched Client</strong>
                              </Typography>
                            </>
                          }
                          sx={{ fontSize: "14px" }}
                        >
                          <Link
                            to={`/profile/customer/${lastCustomerId}`}
                            className={classes.iconLinkPropNormal}
                          >
                            <IconButton
                              aria-haspopup="true"
                              className={classes.topbarButton}
                              onClick={() =>
                                navigate(`/profile/customer/${lastCustomerId}`)
                              }
                            >
                              <PersonSearchRoundedIcon
                                className={classes.topbarIcon}
                              />
                            </IconButton>
                          </Link>
                        </Tooltip>
                      )}
                      <IconButton
                        onClick={handleClickNotificationPopUp}
                        className={classes.topbarButton}
                        aria-haspopup="true"
                        aria-label={
                          unreadCount > 0 ? `Notifications, ${unreadCount} unread` : "Notifications"
                        }
                        title="Notifications"
                      >
                        <Badge
                          badgeContent={unreadCount > 0 ? unreadCount : null}
                          overlap="circular"
                          color="error"
                          max={99}
                        >
                          <MdOutlineNotificationsNone
                            className={classes.topbarIcon}
                          />
                        </Badge>
                      </IconButton>
                      <IconButton
                        onClick={toggleTheme}
                        aria-label={
                          mode === "light" ? "Switch to dark mode" : "Switch to light mode"
                        }
                        title={mode === "light" ? "Switch to dark mode" : "Switch to light mode"}
                        className={classes.topbarButton}
                      >
                        {mode == "light" ? (
                          <MdDarkMode className={classes.topbarIcon} />
                        ) : (
                          <MdDarkMode className={classes.topbarIcon} />
                        )}
                      </IconButton>
                      <IconButton
                        onClick={handleClickProfilePopUp}
                        className={classes.topbarButton}
                        aria-haspopup="true"
                        aria-label="Account menu"
                        title="Account"
                      >
                        <AccountCircleRoundedIcon
                          className={classes.topbarIcon}
                        />
                      </IconButton>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
              <Profile
                profile={profilePopUp}
                onClose={handleCloseProfilePopUp}
                open={openProfilePopUp}
                username={username}
                staffName={staffName}
              />
              <Notification
                notification={notificationPopUp}
                onClose={handleCloseNotificationPopUp}
                open={openNotificationPopUp}
                notificationData={notificationList}
              />
            </Toolbar>

            <>
              <MobileDrawer
                open={mobileDrawerOpen}
                onClose={handleMobileDrawerClose}
              >
                <DrawerHeader>
                  {open && (
                    <img
                      src={LogoMain}
                      alt="AttoDesk Login"
                      style={logoStyle}
                      onClick={handleImgClick}
                    />
                  )}
                  <IconButton
                    className={classes.topbarButton}
                    onClick={handleMobileDrawerClose}
                  >
                    {theme.direction === "rtl" ? (
                      <ChevronRightIcon className={classes.topbarIcon} />
                    ) : (
                      <ChevronLeftIcon className={classes.topbarIcon} />
                    )}
                  </IconButton>
                </DrawerHeader>
                <DrawerContent sx={{ padding: open ? 1 : 0 }}>
                  {MainMenuList.map((ml, index) => {
                    const hasPrivilege =
                      ml.menuList?.some((menuItem) =>
                        canSeeMenuItem(menuItem)
                      ) ||
                      ml.menuList?.some((menuItem) =>
                        menuItem.submenus?.some((submenu) =>
                          canSeeMenuItem(submenu)
                        )
                      );

                    return (
                      <React.Fragment key={index}>
                        {/* {index === 0 && open && (
                          <Grid
                            container
                            spacing={2}
                            justifyContent="center"
                            alignItems="center"
                            textAlign="center"
                          >
                            <List
                              sx={{
                                borderBottom: `1px solid ${theme.palette.background.default}`,
                                paddingBottom: 2,
                                paddingTop: 2,
                                marginBottom: open ? 3 : 0,
                              }}
                            >
                              <ListItemButton>
                                <ListItemIcon>
                                  <Avatar
                                    alt="Travis Howard"
                                    src={UserImg}
                                    className={classes.topbarIconProfileImg}
                                  />
                                </ListItemIcon>
                                <ListItemText className={classes.h4QuotoImg}>
                                  {username}
                                </ListItemText>
                              </ListItemButton>
                            </List>
                          </Grid>
                        )} */}
                        {index === 0 && open && <Box sx={{ height: 20 }}></Box>}
                        {open && hasPrivilege && (
                          <Box>
                            <Typography className={classes.menuTitle}>
                              {ml.comomTitle}
                            </Typography>
                          </Box>
                        )}
                        {ml.menuList && (
                          <List
                            sx={
                              {
                                // borderBottom: "1px solid #878e9f",
                                // paddingBottom: 5,
                                // marginBottom: open ? 5 : 0,
                                // borderBottom:
                                //   open && hasPrivilege
                                //     ? "1px solid #878e9f"
                                //     : "none",
                                // paddingBottom: open && hasPrivilege ? 5 : 0,
                                // marginBottom: open && hasPrivilege ? 5 : 0,
                              }
                            }
                          >
                            {ml.menuList
                              .filter((menuList) =>
                                canSeeMenuItem(menuList)
                              ) // Filter by privilege
                              .map((menuList) => (
                                <ListItem
                                  button
                                  key={menuList.title}
                                  disablePadding
                                  sx={{
                                    display: "block",
                                  }}
                                  onMouseEnter={() =>
                                    handleMenuHover(menuList.path)
                                  }
                                  onMouseLeave={() => setHoveredMenuName("")}
                                >
                                  <ListItemButton
                                    component={
                                      menuList.submenus &&
                                      menuList.submenus.length > 0
                                        ? "div"
                                        : Link
                                    }
                                    to={
                                      menuList.submenus &&
                                      menuList.submenus.length > 0
                                        ? undefined
                                        : menuList.path
                                    }
                                    target="_self"
                                    onClick={() =>
                                      handleMainMenuItemClick(menuList)
                                    }
                                    sx={mainMenuItemSx(menuList.path)}
                                  >
                                    <ListItemIcon
                                      className={classes.listItemIcomMainMenu}
                                    >
                                      {menuList.icon as React.ReactNode}
                                    </ListItemIcon>
                                    <ListItemText
                                      className={classes.menuListItemText}
                                    >
                                      {menuList.title}
                                    </ListItemText>
                                    <ListItemIcon
                                      className={classes.listItemIcomMainMenu}
                                      sx={{
                                        display: "flex",
                                        textAlign: "end",
                                        justifyContent: "flex-end",
                                      }}
                                    >
                                      {menuList.submenus &&
                                        (expandMenu === menuList.title ? (
                                          <ExpandLessIcon
                                            sx={{
                                              fontSize: "18px",
                                              display: "flex",
                                              textAlign: "end",
                                              justifyContent: "flex-end",
                                              "&:hover": {
                                                color:
                                                  theme.palette.mainMenuNav
                                                    .hoverColorNavBg,
                                              },
                                              color:
                                                selectedSubmenu?.startsWith(
                                                  menuList.path
                                                ) ||
                                                hoveredMenuName ===
                                                  menuList.path ||
                                                currentMenuName ===
                                                  menuList.path
                                                  ? theme.palette.mainMenuNav
                                                      .hoverColorNavBg
                                                  : currentMenuName ===
                                                    menuList.path
                                                  ? theme.palette.mainMenuNav
                                                      .hoverColorNavBg
                                                  : theme.palette.topbarButton
                                                      .drawerMenuText,
                                              opacity:
                                                selectedSubmenu?.startsWith(
                                                  menuList.path
                                                ) ||
                                                hoveredMenuName ===
                                                  menuList.path ||
                                                currentMenuName ===
                                                  menuList.path
                                                  ? 1
                                                  : 0.6,
                                            }}
                                          />
                                        ) : (
                                          <ExpandMoreIcon
                                            sx={{
                                              fontSize: "18px",
                                              display: "flex",
                                              textAlign: "end",
                                              justifyContent: "flex-end",
                                              "&:hover": {
                                                color:
                                                  theme.palette.mainMenuNav
                                                    .hoverColorNavBg,
                                              },
                                              color:
                                                selectedSubmenu?.startsWith(
                                                  menuList.path
                                                ) ||
                                                hoveredMenuName ===
                                                  menuList.path ||
                                                currentMenuName ===
                                                  menuList.path
                                                  ? theme.palette.mainMenuNav
                                                      .hoverColorNavBg
                                                  : currentMenuName ===
                                                    menuList.path
                                                  ? theme.palette.mainMenuNav
                                                      .hoverColorNavBg
                                                  : theme.palette.topbarButton
                                                      .drawerMenuText,
                                              opacity:
                                                selectedSubmenu?.startsWith(
                                                  menuList.path
                                                ) ||
                                                hoveredMenuName ===
                                                  menuList.path ||
                                                currentMenuName ===
                                                  menuList.path
                                                  ? 1
                                                  : 0.6,
                                            }}
                                          />
                                        ))}
                                    </ListItemIcon>
                                  </ListItemButton>
                                  {menuList.submenus && (
                                    <Collapse
                                      in={expandMenu === menuList.title}
                                      timeout="auto"
                                      unmountOnExit
                                    >
                                      <List>
                                        {menuList.submenus
                                          .filter((submenu) =>
                                            canSeeMenuItem(submenu)
                                          )
                                          .map((submenu) => (
                                            <ListItem
                                              disablePadding
                                              key={submenu.title}
                                              onMouseEnter={() =>
                                                setHoveredSubmenu(submenu.path)
                                              }
                                              onMouseLeave={() =>
                                                setHoveredSubmenu("")
                                              }
                                            >
                                              <ListItemButton
                                                component={Link}
                                                to={submenu.path}
                                                target="_self"
                                                onClick={() =>
                                                  handleSubmenuItemClicked(
                                                    submenu
                                                  )
                                                }
                                                sx={subMenuItemSx(submenu.path)}
                                              >
                                                <ListItemText
                                                  className={
                                                    classes.menuListItemText
                                                  }
                                                >
                                                  <Typography>
                                                    {submenu.title}
                                                  </Typography>
                                                </ListItemText>
                                              </ListItemButton>
                                            </ListItem>
                                          ))}
                                      </List>
                                    </Collapse>
                                  )}
                                </ListItem>
                              ))}
                          </List>
                        )}
                      </React.Fragment>
                    );
                  })}
                </DrawerContent>
              </MobileDrawer>
            </>
          </AppBar>
        </Box>
      )}

      {/**
       * The content region. Every route in the application renders inside this
       * box, so the page ground, the gutter and the overflow guard are set once
       * here rather than being re-decided by each screen.
       */}
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          padding: { xs: 1.5, sm: 2, md: 3 },
          width: open ? `calc(100% - ${drawerWidth}px)` : "100%",
          /* The page ground. Cards read as surfaces sitting on it rather than
             as white blocks on white. */
          backgroundColor: theme.palette.background.default,
          minHeight: "100vh",
          /* No page-level horizontal scrollbar, ever. Wide children (data
             tables, chart rows) scroll inside their own container instead. */
          minWidth: 0,
          overflowX: "hidden",
        }}
      >
        <PaddingBody />
        {children}
      </Box>
    </Box>
  );
}
